import { Button } from '@/components/ui/button'
import { ArrowRight, CheckCircle2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function Hero() {
  const navigate = useNavigate()

  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-gradient-to-br from-slate-50 to-white">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-slate-100/50 -skew-x-12 translate-x-1/4 -z-10" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-emerald/5 rounded-full blur-3xl -z-10" />

      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left space-y-8 animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-emerald/10 text-brand-emerald text-sm font-medium border border-brand-emerald/20">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
              </span>
              Contrate para inicio imediato
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-navy leading-tight tracking-tight">
              Está faltando educador na{' '}
              <span className="text-brand-emerald">sua escola?</span>
            </h1>

            <p className="text-xl md:text-2xl font-semibold text-slate-600 max-w-2xl mx-auto lg:mx-0">
              Cada dia com vaga aberta vira prejuízo. Encontre profissionais
              qualificados em tempo recorde.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4">
              <Button
                size="lg"
                className="w-full sm:w-auto text-lg h-14 px-8 bg-brand-emerald hover:bg-emerald-600 shadow-glow animate-pulse-subtle"
                onClick={() => navigate('/anunciar-vaga')}
              >
                👉 Criar vaga agora (gratuito)
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="w-full sm:w-auto text-lg h-14 px-8 border-slate-300 text-slate-700 hover:bg-slate-50 hover:text-brand-blue"
                onClick={() => navigate('/cadastro-educador')}
              >
                procurar vaga <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </div>

            <div className="pt-4 flex items-center justify-center lg:justify-start gap-6 text-sm text-slate-500">
              <div className="flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-brand-emerald" />
                <span>Sem custo para anunciar</span>
              </div>
              <div className="flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-brand-emerald" />
                <span>Banco de talentos verificado</span>
              </div>
            </div>
          </div>

          {/* Visual Content */}
          <div className="flex-1 w-full relative animate-fade-in lg:animate-slide-up">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white aspect-[4/3] group">
              <img
                src="https://img.usecurling.com/p/1200/800?q=classroom%20students%20no%20teacher"
                alt="Sala de aula com alunos sem professor"
                className="object-cover w-full h-full transform transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
                <div className="text-white">
                  <p className="font-bold text-lg">Ambiente Escolar</p>
                  <p className="text-sm opacity-90">
                    Conectando quem ensina a quem precisa.
                  </p>
                </div>
              </div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-12 bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-4 animate-float hidden sm:flex">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-brand-blue">
                <img
                  src="https://img.usecurling.com/i?q=brazil%20map&shape=outline&color=blue"
                  alt="Mapa do Brasil"
                  className="w-8 h-8 opacity-80"
                />
              </div>
              <div>
                <p className="text-brand-navy font-bold text-base">
                  Candidatos em todo Brasil
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
